// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1a6848c","239":"782d8ec4","453":"39536b27","667":"9bd93f32"}[chunkId] + ".chunk.js";
};